import { makeStyles } from "tss-react/mui";
import { MiBadge, MiButton, MiChip, MiIcon } from "@miplatform/components";
import { BUTTON_VARIANTS } from "@miplatform/constants";
import { ICategoriesResponse, ICategoryDropsResponse } from "@miplatform/types";
import { mdiChevronDown } from "@mdi/js";
import { AccordionSummary, Box, Typography } from "@mui/material";

export function AccordionHeader({
  readOnly = false,
  category,
  categoryDrop,
  disabled,
  handleOpenDropTypeSelect,
}: AccordionHeaderProps) {
  const { classes, theme } = useStyles();

  return (
    <AccordionSummary
      expandIcon={<MiIcon path={mdiChevronDown} />}
      className={classes.accordionSummary}
    >
      <Box className={classes.categoryHeader}>
        <MiBadge
          text={categoryDrop.length}
          rounded
          backgroundColor={theme.palette.grey.main}
          className={classes.miBadge}
        />
        <Typography className={classes.categoryTitle}>
          {category.name}
        </Typography>
        {category.dropRequired && (
          <MiChip
            label="Requires Drop"
            size="small"
            className={classes.dropChip}
          />
        )}
      </Box>
      {!readOnly && (
        <MiButton
          title="Select Drop Types"
          variant={BUTTON_VARIANTS.OUTLINED}
          startIcon={{ path: mdiChevronDown }}
          size="small"
          className={classes.addButton}
          disabled={disabled}
          onClick={(e) =>
            handleOpenDropTypeSelect(e, category.id, categoryDrop)
          }
        />
      )}
    </AccordionSummary>
  );
}

const useStyles = makeStyles()((theme) => ({
  accordionSummary: {
    minHeight: 0,
    padding: theme.spacing(0.5, 2),
    backgroundColor: theme.palette.grey.mediumLight,
    "& .MuiAccordionSummary-content": {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      margin: 0,
    },
    "& .MuiAccordionSummary-content.Mui-expanded": {
      margin: 0,
    },
    "&.Mui-expanded": {
      minHeight: 0,
    },
  },
  categoryHeader: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
  },
  miBadge: {
    width: "20px !important",
    height: 20,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  categoryTitle: {
    fontWeight: theme.fontWeight.semiBold,
    fontSize: theme.fontSize.medium,
  },
  dropChip: {
    border: `1px solid ${theme.palette.orange.main}`,
    backgroundColor: theme.palette.orange.light,
    borderRadius: 4,
    height: 20,
    color: theme.palette.orange.main,
  },
  addButton: {
    marginRight: theme.spacing(2),
    backgroundColor: theme.palette.common.white,
  },
}));

interface AccordionHeaderProps {
  readOnly?: boolean;
  category: ICategoriesResponse;
  categoryDrop: ICategoryDropsResponse[];
  disabled: boolean;
  handleOpenDropTypeSelect: (
    event: React.MouseEvent<HTMLElement>,
    categoryId: string,
    categoryDrop: ICategoryDropsResponse[]
  ) => void;
}
